import React from 'react';
import styled from 'styled-components/macro';
import MainDetails from './MainDetails/MainDetails';
import { SpecificationProps } from '../types';
import SampleStructure from './SampleStructure/SampleStructure';
import { SeparatorLine } from './Common/Separator';

const Content = styled.div`
  padding: 2.5rem 0;
  margin-left: 2rem;
`;
interface Props {
  data: SpecificationProps;
}

const Specification = ({ data }: Props) => {
  const { main_details: mainDetails, sample_structure: sampleStructure } = data;

  return (
    <Content>
      <MainDetails data={mainDetails} />
      <SeparatorLine />
      <SampleStructure data={sampleStructure} />
    </Content>
  );
};

export default Specification;
